var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextCellComponent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 98 102",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: none;\n      }\n\n      .st1 {\n        fill: #707070;\n      }\n\n      .st2 {\n        fill: #828282;\n      }\n\n      .st3 {\n        isolation: isolate;\n      }\n\n      .st4 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_104815"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_146226"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    width: 98,
    height: 102,
    rx: 4,
    ry: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M94,102H4c-2.2,0-4-1.8-4-4V4C0,1.8,1.8,0,4,0h90c2.2,0,4,1.8,4,4v94c0,2.2-1.8,4-4,4ZM4,1c-1.7,0-3,1.3-3,3v94c0,1.7,1.3,3,3,3h90c1.7,0,3-1.3,3-3V4c0-1.7-1.3-3-3-3H4Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Two",
    className: "st3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M35.2,79.9h-2.2v6.1h-1.2v-6.1h-2.2v-1h5.6v1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M38.3,86.1c-.8,0-1.4-.2-1.8-.7-.5-.5-.7-1.1-.7-1.9h0c0-.7.1-1.1.3-1.6.2-.4.5-.7.9-1,.4-.2.8-.3,1.2-.3.7,0,1.3.2,1.7.7.4.5.6,1.1.6,1.9v.5h-3.5c0,.4.2.8.4,1,.3.3.6.4,1,.4s1-.2,1.3-.7l.6.6c-.2.3-.5.6-.8.7-.4.2-.8.3-1.2.3ZM38.2,81.6c-.3,0-.6.1-.8.3s-.3.5-.4,1h2.3c0-.5-.1-.8-.3-1-.2-.2-.4-.3-.8-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M43.3,82.5l1-1.7h1.3l-1.6,2.6,1.7,2.7h-1.3l-1.1-1.8-1,1.8h-1.3l1.7-2.7-1.6-2.6h1.3l1,1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M47.9,79.4v1.3h.9v.9h-.9v2.9c0,.2,0,.3.1.4,0,0,.2.1.4.1s.3,0,.4,0v.9c-.3,0-.5.1-.8.1-.9,0-1.4-.5-1.4-1.5v-3h-.9v-.9h.9v-1.3h1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M57.8,83.7c0,.8-.4,1.3-.8,1.8-.5.4-1.1.6-1.9.6s-1.1-.1-1.5-.4c-.4-.3-.8-.7-1-1.1s-.4-1.1-.4-1.7v-.7c0-.7.1-1.3.4-1.8.2-.5.6-.9,1-1.2s1-.4,1.5-.4,1.4.2,1.9.6c.5.4.8,1,.8,1.8h-1.2c0-.5-.2-.9-.4-1.1-.2-.2-.6-.3-1.1-.3s-.9.2-1.2.6-.4,1-.4,1.7v.6c0,.8.1,1.4.4,1.8.3.4.7.6,1.2.6s.8-.1,1.1-.3.4-.6.5-1.1h1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M61.1,86.1c-.8,0-1.4-.2-1.8-.7-.5-.5-.7-1.1-.7-1.9h0c0-.7.1-1.1.3-1.6.2-.4.5-.7.9-1,.4-.2.8-.3,1.2-.3.7,0,1.3.2,1.7.7.4.5.6,1.1.6,1.9v.5h-3.5c0,.4.2.8.4,1,.3.3.6.4,1,.4s1-.2,1.3-.7l.6.6c-.2.3-.5.6-.8.7-.4.2-.8.3-1.2.3ZM60.9,81.6c-.3,0-.6.1-.8.3s-.3.5-.4,1h2.3c0-.5-.1-.8-.3-1-.2-.2-.4-.3-.8-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M65.4,86h-1.2v-7.5h1.2v7.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M67.9,86h-1.2v-7.5h1.2v7.5Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "add_photo_alternate_black_24dp"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61965",
    className: "st0",
    d: "M21.9,16.6h54.3v54.3H21.9V16.6Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_79017"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_146326"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 25.5,
    y: 20.3,
    width: 47,
    height: 47,
    rx: 7,
    ry: 7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M65.5,67.3h-33c-3.9,0-7-3.1-7-7V27.3c0-3.9,3.1-7,7-7h33c3.9,0,7,3.1,7,7v33c0,3.9-3.1,7-7,7ZM32.5,21.3c-3.3,0-6,2.7-6,6v33c0,3.3,2.7,6,6,6h33c3.3,0,6-2.7,6-6V27.3c0-3.3-2.7-6-6-6h-33Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48.5,56.5c-.4,0-.8-.3-.8-.8v-24c0-.4.3-.8.8-.8s.8.3.8.8v24c0,.4-.3.8-.8.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M61,44.5h-24c-.4,0-.8-.3-.8-.8s.3-.8.8-.8h24c.4,0,.8.3.8.8s-.3.8-.8.8Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextCellComponent);
export default __webpack_public_path__ + "static/media/TextCellComponent.cadfa309847744665033e975872ae610.svg";
export { ForwardRef as ReactComponent };